<mat-toolbar>
  <span>{{ 'FORM.CHECK_DETAILS' | transloco }}</span>
</mat-toolbar>
<div class="row">
  <div class="col">
    <mat-list>

      <h3 matSubheader>{{ 'FORM.NAME' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>person</mat-icon>
        <h4 matLine>{{userInput.customer.customer.firstname}} {{userInput.customer.customer.lastname}}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.PHONENUMBER' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>smartphone</mat-icon>
        <h4 matLine>{{userInput.customer.customer.cellular}}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>Email</h3>
      <mat-list-item>
        <mat-icon matListIcon>email</mat-icon>
        <h4 matLine>{{userInput.customer.customer.email}}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.PERSONS' | transloco }}</h3>
      @if (userInput.customer?.shuttles) {
        <mat-list-item>
          <mat-icon matListIcon>people</mat-icon>
          <h4 matLine>{{userInput.customer?.shuttles[0]?.passengers}}</h4>
        </mat-list-item>
      }

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.CARID' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>directions_car</mat-icon>
        <h4 matLine>{{ userInput.customer.parking.carId }}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

    </mat-list>
  </div>
  <div class="col">
    <mat-list>

      <h3 matSubheader>{{ 'FORM.PARKING_FROM' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>local_parking</mat-icon>
        <h4 matLine>{{ userInput.customer.parking.parkingFrom | date : 'yyyy-MM-dd'}} Kl: {{
          userInput.customer.parking.parkingFrom | date : 'HH:mm'}}
        </h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.PARKING_TO' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>local_parking</mat-icon>
        <h4 matLine>{{ userInput.customer.parking.parkingTo | date : 'yyyy-MM-dd'}} Kl: {{
          userInput.customer.parking.parkingTo | date : 'HH:mm'}}
        </h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.DEPARTURE_FLIGHTNUMBER' | transloco }}</h3>
      @if (userInput.customer.shuttles) {
        <mat-list-item>
          <mat-icon matListIcon>flight_takeoff</mat-icon>
          <h4 matLine>{{ userInput.customer.shuttles[0].flightnr }}</h4>
        </mat-list-item>
      }

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.ARRIVAL_FLIGHTNUMBER' | transloco }}</h3>
      @if (userInput.customer.shuttles) {
        <mat-list-item>
          <mat-icon matListIcon>flight_land</mat-icon>
          <h4 matLine>{{ userInput.customer.shuttles[1].flightnr }}</h4>
        </mat-list-item>
      }

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'PLACEHOLDER.TRAVEL_AGENT' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>loyalty</mat-icon>
        <h4 matLine>{{ userInput.customer.order.bundleCode }} - {{ userInput.customer.parking.productCode }}
        </h4>
      </mat-list-item>

      <mat-divider></mat-divider>

    </mat-list>
  </div>

</div>

<mat-toolbar> {{ 'PLACEHOLDER.BOOKING_PRICE' | transloco }}<div class="spacer"></div>{{userInput.cart.totalPriceIncVat}}
SEK
</mat-toolbar>

<mat-action-list>
  <button mat-raised-button type="button" class="button-size" (click)="cancel()" style="width: 50%;" color="warn">
    {{ 'FORM.EDIT' | transloco | uppercase}}
  </button>

  <button mat-raised-button type="button" [disabled]="isLoading" (click)="sendConfirmation()"
    class="success-button button-size">
    @if (isLoading) {
      <mat-icon>
        <mat-spinner color="accent" diameter="20">
        </mat-spinner>
      </mat-icon>
      }{{ 'FORM.CONFIRM' | transloco | uppercase}}
    </button>

  </mat-action-list>